export const formatBooleanAsPill = (value) => {
  const pillStyle = {
    padding: '4px 12px',
    borderRadius: '16px',
    fontSize: '14px',
    fontWeight: '500',
    display: 'inline-block',
  };
  return value ? (
    <span
      style={{ ...pillStyle, backgroundColor: '#ECFDF3', color: '#027A48' }}
    >
      Da
    </span>
  ) : (
    <span
      style={{ ...pillStyle, backgroundColor: '#FEF3F2', color: '#B42318' }}
    >
      Ne
    </span>
  );
};
